if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
      this.ensureDefaultSelections();
      this.hideUnavailableDependentValues();
    }

    ensureDefaultSelections() {
      const changedTargets = [];
      const pickerFields = this.querySelectorAll("[data-picker-field]");
      pickerFields.forEach((field) => {
        const fieldType = field.dataset.pickerField;
        if (fieldType === "select") {
          const select = field.querySelector("select");
          if (!select) return;
          const currentSelected = select.selectedOptions[0];
          if (currentSelected && !currentSelected.disabled) return;
          const firstEnabled = Array.from(select.options).find(
            (option) => !option.disabled
          );
          if (firstEnabled && (!currentSelected || !firstEnabled.selected)) {
            select.value = firstEnabled.value;
            changedTargets.push(select);
          }
        } else {
          const checkedInput = field.querySelector("input:checked");
          if (
            checkedInput &&
            !checkedInput.classList.contains("disabled")
          )
            return;
          const firstEnabled = field.querySelector("input:not(.disabled)");
          if (firstEnabled) {
            firstEnabled.checked = true;
            changedTargets.push(firstEnabled);
          }
        }
      });
      if (changedTargets.length) {
        const lastTarget = changedTargets[changedTargets.length - 1];
        lastTarget.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    hideUnavailableDependentValues() {
      const changedTargets = [];
      const pickerFields = this.querySelectorAll("[data-picker-field]");
      pickerFields.forEach((field, index) => {
        if (index === 0) return;
        const fieldType = field.dataset.pickerField;
        if (fieldType === "select") {
          const options = field.querySelectorAll("option");
          options.forEach((option) => {
            option.toggleAttribute("hidden", option.disabled);
          });
          const select = field.querySelector("select");
          if (!select) return;
          const currentSelected = select.selectedOptions[0];
          if (currentSelected && !currentSelected.hidden && !currentSelected.disabled) return;
          const firstEnabled = Array.from(select.options).find(
            (option) => !option.disabled && !option.hidden
          );
          if (firstEnabled) {
            select.value = firstEnabled.value;
            changedTargets.push(select);
          }
        } else {
          let hasValidSelection = !!field.querySelector(
            "input:checked:not(.disabled)"
          );
          field.querySelectorAll(".variant-picker__option").forEach((optionNode) => {
            const input = optionNode.querySelector("input");
            if (!input) return;
            const shouldHide = input.classList.contains("disabled");
            optionNode.classList.toggle(
              "variant-picker__option--hidden",
              shouldHide
            );
            if (shouldHide && input.checked) {
              input.checked = false;
              hasValidSelection = false;
            }
          });
          if (!hasValidSelection) {
            const firstAvailable = field.querySelector(
              ".variant-picker__option:not(.variant-picker__option--hidden) input:not(.disabled)"
            );
            if (firstAvailable) {
              firstAvailable.checked = true;
              changedTargets.push(firstAvailable);
            }
          }
        }
      });
      if (changedTargets.length) {
        const lastTarget = changedTargets[changedTargets.length - 1];
        lastTarget.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
